import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { APP } from '@/common/strings'
import { NAVIGATION_COPY } from '@/locales/en'
import { DetailListSection } from '@/common/ui/DetailListSection'
import { H1 } from '@/common/ui/h1'
import { useCurrentAccount } from '@/account/useCurrentAccount'
import { useAccountSettingsItems } from './model/useAccountSettingsItems'
import { ActionableDetailItemRow } from './components/SettingsListItems'
import { getAccountPageEditViewRoute } from '@/common/navigation/accountRoutes'

export default function AccountSettingsView() {
    const navigate = useNavigate()
    const account = useCurrentAccount()

    const accountSettingsDetails = useAccountSettingsItems({
        onAddAdviserTradeConfirmation: () => {
            navigate(getAccountPageEditViewRoute('trade-confirmation'))
        },
        onAddAdviserRegistrationAddress: () => {
            navigate(getAccountPageEditViewRoute('registration-address'))
        },
    })

    const copy = NAVIGATION_COPY.account

    if (!account) {
        return null
    }

    return (
        <>
            <Helmet>
                <title>
                    {copy.pageTitle} | {APP.title}
                </title>
            </Helmet>

            <div className="self-stretch inline-flex justify-start items-center gap-2.5 md:hidden">
                <H1 className="leading-10 mb-0">{copy.tabs.accountSettings}</H1>
            </div>

            <div className="self-stretch flex flex-col justify-start items-start gap-4 md:gap-6">
                <DetailListSection
                    title={copy.tradeConfirmationTitle}
                    items={accountSettingsDetails.tradeConfirmation}
                    renderItem={(item) => <ActionableDetailItemRow item={item} />}
                />
                <DetailListSection
                    title={copy.registryCommunicationTitle}
                    items={accountSettingsDetails.registryCommunication}
                    renderItem={(item) => <ActionableDetailItemRow item={item} />}
                />
            </div>
        </>
    )
}
